import { useDidMount } from '@cian/valuation-utils-component';

import { preloadImagesFromResponse } from './preloadImagesFromResponse';
import { TFormStoreData } from '../../../types/form';

/**
 * Процессы инициализации, когда компонент с формой отрендерился
 * Выполняет предзагрузку всех картинок из вопросов формы, чтоб они быстро брались из кэша
 * */
export const useOnRenderedInBrowser = (formData: TFormStoreData) => {
  useDidMount(() => {
    /* istanbul ignore else */
    if (typeof window !== 'undefined') {
      preloadImagesFromResponse(formData);
    }
  });
};
